import { Button, Card, Typography } from '@material-tailwind/react';
import APRPLogo from "../assets/images/APRPLogo.png"
import DXCLogo from "../assets/images/sponsors/DXC Logo_White RGB.png"
import TeromovigoLogo from "../assets/images/sponsors/teromovigo-logo65h.png"
import AmiSantosLogo from "../assets/images/sponsors/amiSantos.jpg"
import UBILogo from "../assets/images/ubi_logo_fundo.png"
import deepLogo from "../assets/images/deepneuronic_logo_white.png"

interface FooterProps {
}

export function Footer({ }: FooterProps) {
  // Function to open URLs in a new tab
  const openUrl = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <section className={`pt-4 relative bg-footer-500 `} >
      <div className="flex flex-col lg:flex-row text-center gap-10 lg:gap-16 container mx-auto justify-center items-center py-8 lg:py-12" >
        <div>

          <Typography variant="lead" color="white" className="mb-2">
            Organized by:
          </Typography>

          <div className="w-full flex items-center justify-center p-4 gap-12 flex-col md:flex-row " >

            <img onClick={() => openUrl("https://aprp.pt/en/home/")} className="h-12 cursor-pointer" src={APRPLogo} alt="APRP" />
            <img onClick={() => openUrl("https://www.ubi.pt/Default.aspx")} className="h-12 cursor-pointer" src={UBILogo} alt="UBI" />
            <img onClick={() => openUrl("https://deepneuronic.com/")} className="h-12 cursor-pointer" src={deepLogo} alt="DeepNeuronic" />

          </div>

        </div>

        <div>

          <Typography variant="lead" color="white" className="mb-2">
            Sponsored by:
          </Typography>

          <div>
          <div className="w-full flex items-center justify-center pb-4 gap-12" >
            {/* <img onClick={() => openUrl("https://aprp.pt/en/home/")} className="h-12 cursor-pointer" src={APRPLogo} alt="APRP" /> */}
            <img onClick={() => openUrl("https://dxc.com")} className="h-[82px] cursor-pointer" src={DXCLogo} alt="APRP" />
          </div>
          <div className="w-full flex items-center justify-center  gap-12" >
            <img onClick={() => openUrl("https://teromovigo.com/")} className="h-6 cursor-pointer" src={TeromovigoLogo} alt="APRP" />
            <img onClick={() => openUrl("https://www.facebook.com/p/Ami-Santos-100063679533180")} className="h-10 cursor-pointer" src={AmiSantosLogo} alt="APRP" />
          </div>
          </div>

  

        </div>
      </div>

      <div className="w-[90%] h-[1px] bg-white mx-auto mb-12" ></div>

      <div className="w-full py-5 bg-footer-600 mt-4 text-center" >
        <Typography variant="paragraph" color="white" className="">

          RECPAD 2024 |{" "}
          <a href="https://deepneuronic.com" target="_blank" className="cursor-pointer hover:underline">
            Developed by DeepNeuronic
          </a>
        </Typography>
      </div>


    </section>
  );
}
